import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import {  ManageAccounts } from '@mui/icons-material'

function AdminLandingPage() {
    return (
    <AppLayout>
        <div className='container'>
            <div className='row mt-5 text-center'>
            <div className='col-md-6 my-3'>
                <div className='card bg-primary p-3 ' >
                    <Link to={"/user/list"} className='btn text-white'   >
                    <h3><ManageAccounts style={{fontSize:60}} /></h3>
                    <p>Manage User</p>
                    </Link>
                </div>
            </div>
            </div>
        </div>
    </AppLayout>
    )
}

export default AdminLandingPage